import {createSvgIcon} from '../create-svg-icon';

export const DoorBackIcon = createSvgIcon(
  [<path d="M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14z" key="0" />,<path d="M9 11h2v2H9z" key="1" />,]
, 'DoorBackOutlined');
